import { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { CounterInputV2, InputV2 } from "../../../FormControlsV2";
import { MessageBalloon } from "../../../MessageBalloon/Index";
import { ReactComponent as PointIcon } from "../../../../assets/svg/icons/point.svg";
import { ReactComponent as AreaIcon } from "../../../../assets/svg/icons/areaIcon.svg";
import { ReactComponent as AnimalsIcon } from "../../../../assets/svg/icons/animais.svg";
import { ReactComponent as GrassIcon } from "../../../../assets/svg/icons/grass.svg";
import { ButtonPressed } from "../../../Buttons/ButtonPressed";
import { ButtonYesOrNo } from "../../../Buttons/ButtonYesOrNo";
import { format } from "date-fns";

interface InfoProductDispatchProps {
  task: ITaskProductDispatch | undefined;
}

export default function InfoProductDispatch(task: InfoProductDispatchProps) {
  const { t } = useTranslation();
  const [taskProductDispatch, setTaskProductDispatch] =
    useState<ITaskProductDispatch>();
  useEffect(() => {
    setTaskProductDispatch(task.task);
  }, [task.task]);

  const mapText = new Map();
  mapText.set("FULL", "Cheio");
  mapText.set("EMPTY", "Vazio");
  mapText.set("MEDIUM", "Médio");
  mapText.set("DEPOSITO_CENTRAL", "Depósito Central");
  mapText.set("DEPOSITO_PASTO", "Depósito do Pasto");

  return (
    <>
      <div>
        <span><Trans i18nKey="taskDetails.onPaddock" /></span>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <GrassIcon width={30} className="iconInitialTaskInfo" />
          <div className="labelInitialTaskInfo">
            <span>{taskProductDispatch?.initials}</span>
            <PointIcon width={15} />
          </div>
        </div>
      </div>

      <div className="containerQuestion">
        <MessageBalloon
          text={t("messageBalloon.productOrigin")}
          pointed
        />
        <ButtonPressed
          onlyResult
          optionSelected={1}
          value={1}
          text={`${mapText.get(taskProductDispatch?.source)}`}
        />
      </div>

      <div className="containerQuestion">
        <MessageBalloon
          text={t("messageBalloon.productDestination")}
          pointed
        />
        <ButtonPressed
          onlyResult
          optionSelected={1}
          value={1}
          text={`${taskProductDispatch?.dispatch_type}`}
        />
      </div>

      {taskProductDispatch && taskProductDispatch?.details.length > 0
        ? taskProductDispatch?.details.map((detail, index) => (
            <div key={index} className="containerQuestion">
              <MessageBalloon
                text={`${detail.supplement_classification} - ${detail.trade_name}`}
                pointed
              />
              <CounterInputV2
                name={`info-product-dispatch-qty-${index}`}
                label={detail.bag_quantity_equivalent != null
                  ? t("productPackaging.bagQuantity")
                  : t("productPackaging.totalWeight")}
                suffix={detail.bag_quantity_equivalent != null
                  ? t("productPackaging.bags")
                  : "kg"}
                value={String(detail.bag_quantity_equivalent ?? detail.quantity_kg ?? 0)}
                description={detail.bag_quantity_equivalent != null
                  ? t("productPackaging.kgEquivalent", { value: detail.quantity_kg ?? 0 })
                  : undefined}
                disabled
                allowDecimal
              />
            </div>
          ))
        : null}

      {taskProductDispatch?.dispatch_type == "COCHO" ? (
        <>
          <div className="containerQuestion">
            <MessageBalloon text={t("messageBalloon.troughCondition")} pointed />
            <ButtonPressed
              onlyResult
              optionSelected={1}
              value={1}
              text={`${mapText.get(taskProductDispatch?.trough_status)}`}
            />
          </div>

          <div className="containerQuestion">
            <MessageBalloon text={t("messageBalloon.productLoss")} pointed />
            <ButtonPressed
              onlyResult
              optionSelected={1}
              value={1}
              text={`${taskProductDispatch?.quantity_estimated_loss != 0 ? "Sim" : "Não"}`}
            />
          </div>

          {taskProductDispatch?.quantity_estimated_loss != 0 ? (
            <>
              <CounterInputV2
                name="info-product-dispatch-loss"
                suffix="kg"
                value={String(
                  taskProductDispatch?.quantity_estimated_loss ?? "",
                )}
                disabled
                allowDecimal
              />
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <></>
      )}
    </>
  );
}
